import * as React from "react";

import { cn } from "../../lib/utils";

// Shared max-width primitive — PageHeader's inner row, PageContainer,
// PageFooter's inner row and the /app shell all use this, so every page has
// one width and their edges line up. max-w-6xl (1152) less lg:px-4 leaves a
// 1120px content column, the 12 × 64 + 11 × 32 grid.
export type ContainerProps = React.HTMLAttributes<HTMLDivElement>;

export const Container = React.forwardRef<HTMLDivElement, ContainerProps>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("mx-auto w-full max-w-6xl px-6 sm:px-8 lg:px-4", className)} {...props} />
));
Container.displayName = "Container";
